import { Fragment } from "react";
import { CustomPagination } from "@store/action/GlobalAction";
import { Link } from "react-router-dom";
import PhotoHeader from "./PhotoHeader";
import classNames from "classnames";

const Photos = (props) => {
  const { activeView, setActiveView, store, t, setCurrentPage, getPhoto } =
    props;
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
    dispatch(
      getPhoto({
        page: x.selected + 1,
        find_q: window.location.search,
      })
    );
  };
  const renderData = () => {
    if (store?.recordsTotal > 0) {
      return store?.data?.data?.map((item, i) => {
        return (
          <div className="col-12" key={i}>
            <div className="blog-card">
              <img
                width="100%"
                height="400px"
                src={item.photo_file && item.photo_file}
                alt="blog-1"
              />
              <div className="blog-overlay">
                <p>
                  {new Date(item.date).toLocaleString(`${lang1}-US`, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
                <div className="mail-body">
                  <div className="mail-message">
                    <h3
                      className="text-truncate mb-0"
                      style={{ color: "white" }}
                    >
                      {item.title}
                    </h3>
                  </div>
                </div>
                <Link className="btn btn-outline" to={`topics/${item.id}`}>
                  {t("read more")}
                </Link>
              </div>
            </div>
          </div>
        );
      });
    }
  };
  return (
    <div className="content-detached content-right">
      <PhotoHeader activeView={activeView} setActiveView={setActiveView} />
      {store?.recordsTotal > 0 ? (
        <Fragment>
          <div
            className={classNames({
              "grid-view": activeView === "grid",
              "list-view": activeView === "list",
            })}
          >
            {renderData()}
          </div>
          <div className="d-flex justify-content-center">
            {CustomPagination(store.recordsTotal, 5, handlePageChange)}
          </div>
        </Fragment>
      ) : (
        <div className="d-flex justify-content-center mt-2">
          <p>{t("No Results")}</p>
        </div>
      )}
    </div>
  );
};

export default Photos;
